import { render, staticRenderFns } from "./LegalHolidayAlert.vue?vue&type=template&id=351a8f0d"
import script from "./LegalHolidayAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalHolidayAlert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports